import React from 'react'
import { Form } from '@ztechapps/webui.form'
import { useRegisterContext } from './Context'
import { useSubmitRegister } from './useSubmitRegister'
import { Stack } from 'react-bootstrap'

export const Layout = () => {
  const { components, ...context } = useRegisterContext()
  const { initialValues, validate } = context
  const submitRegister = useSubmitRegister()

  // validateOnBlur is off (Formik still validates on change and on submit): the autofocused
  // Email field's blur fires the instant the Register button gesture starts (its mousedown moves
  // focus away), and Formik's blur-triggered validate() resolves fast enough to insert this
  // field's "Required." message BEFORE the same click's mouseup lands. That insertion shifts
  // every field below it down, so the button moves out from under the pointer between mousedown
  // and mouseup and the click's mouseup never reaches it — handleSubmit is skipped entirely
  // (submitCount stays 0, touched only ever gains the blurred field), which is why only Email
  // showed a message and the summary alert in ErrorDisplay.tsx never appeared (its condition
  // needs submitCount > 0). Reproduced directly: node_modules/formik's SUBMIT_ATTEMPT reducer
  // (formik.cjs.development.js:325-330) touches every field and bumps submitCount, but that
  // dispatch was never observed firing. Disabling blur validation removes the only pre-submit
  // layout shift this form can trigger, so the press always lands on the button.
  return (
    <Form initialValues={initialValues} validate={validate} onSubmit={submitRegister} validateOnBlur={false}>
      <Stack gap={2}>
        <components.errorDisplay />
        <components.form />
        <components.button />
      </Stack>
    </Form>
  )
}
